import { render, staticRenderFns } from "./IdGrid.vue?vue&type=template&id=26ffd72d&scoped=true"
import script from "./IdGrid.vue?vue&type=script&lang=js"
export * from "./IdGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ffd72d",
  null
  
)

export default component.exports